

<section class="carousel slide cid-spu40LlAjL" data-interval="false" id="slider1-2r">
<div class="full-screen"><div class="mbr-slider slide carousel" data-interval="false" data-keyboard="false" data-pause="false" data-ride="false"><ol class="carousel-indicators"><li data-app-prevent-settings="" data-slide-to="0" data-target="#slider1-2r"></li><li data-app-prevent-settings="" data-slide-to="1" data-target="#slider1-2r"></li><li class="active" data-app-prevent-settings="" data-slide-to="2" data-target="#slider1-2r"></li></ol><div class="carousel-inner" role="listbox"><div class="carousel-item slider-fullscreen-image" data-bg-video-slide="false" style="background-image: url(assets/images/senior-investor-buying-startup-handshaking-young-entrepreneur-group-meeting-1280x853.jpg);"><div class="container container-slide"><div class="image_wrapper"><div class="mbr-overlay" style="opacity: 0.7;"></div><img alt="" src="assets/images/senior-investor-buying-startup-handshaking-young-entrepreneur-group-meeting-1280x853.jpg" title=""/><div class="carousel-caption justify-content-center"><div class="col-10 align-center"><h2 class="mbr-fonts-style display-1">Customer Experience Transformation</h2><p class="lead mbr-text mbr-fonts-style display-5">At Vayunam, we know your needs are as unique as your customers, </p><div buttons="0" class="mbr-section-btn"><a class="btn display-4 btn-secondary" routerLink="/digital-transformation">Learn More</a> </div></div></div></div></div></div><div class="carousel-item slider-fullscreen-image" data-bg-video-slide="false" style="background-image: url(assets/images/group-people-working-out-business-plan-office-2000x1333.jpg);"><div class="container container-slide"><div class="image_wrapper"><div class="mbr-overlay" style="opacity: 0.6;"></div><img alt="" src="assets/images/group-people-working-out-business-plan-office-2000x1333.jpg" title=""/><div class="carousel-caption justify-content-center"><div class="col-10 align-left"><h2 class="mbr-fonts-style display-1">Brand Strategy &amp; Management Consulting</h2><p class="lead mbr-text mbr-fonts-style display-5">Experts engaging as part of your team, sharing passion and accountability for results</p></div></div></div></div></div><div class="carousel-item slider-fullscreen-image active" data-bg-video-slide="false" style="background-image: url(assets/images/group-multiethnic-designers-brainstorming-1280x815.jpg);"><div class="container container-slide"><div class="image_wrapper"><div class="mbr-overlay" style="opacity: 0.7;"></div><img alt="" src="assets/images/group-multiethnic-designers-brainstorming-1280x815.jpg" title=""/><div class="carousel-caption justify-content-center"><div class="col-10 align-right"><h2 class="mbr-fonts-style display-1">Design &amp; Technology<div>Creating Value<strong> </strong></div></h2><p class="lead mbr-text mbr-fonts-style display-5">we can help create connected, consistent, and endearing experiences for your customers</p></div></div></div></div></div></div><a class="carousel-control carousel-control-prev" data-app-prevent-settings="" data-slide="prev" href="#slider1-2r" role="button"><span aria-hidden="true" class="mbri-left mbr-iconfont"></span><span class="sr-only">Previous</span></a><a class="carousel-control carousel-control-next" data-app-prevent-settings="" data-slide="next" href="#slider1-2r" role="button"><span aria-hidden="true" class="mbri-right mbr-iconfont"></span><span class="sr-only">Next</span></a></div></div>
</section>
<section class="mbr-section content4 cid-spzNDjenG6" id="content4-2y">
<div class="container">
<div class="media-container-row">
<div class="title col-12 col-md-12">
<h2 class="align-center pb-3 mbr-fonts-style display-2"><strong>WHAT WE DO</strong></h2>
<h3 class="mbr-section-subtitle align-center mbr-light mbr-fonts-style display-5">At Vayunam, we know your needs are as unique as your customers, so we work with you to define your ideal support outcomes and then draw from our suite of experience-focused business solutions to craft a winning strategy</h3>
</div>
</div>
</div>
</section>
<section class="cid-spzNFiI9Om" id="image1-2z">
<figure class="mbr-figure container">
<div class="image-block" style="width: 81%;">
<img alt="Services" src="assets/images/productservicesnew-2x.svg" width="1400"/>
</div>
</figure>
</section>
<section class="features11 cid-spfIs5LsKB" id="features11-2k">
<div class="container">
<div class="col-md-12">
<div class="media-container-row">
<div class="mbr-figure m-auto" style="width: 50%;">
<img alt="Telecom" src="assets/images/telcom5g.svg" title=""/>
</div>
<div class="align-left aside-content">
<h2 class="mbr-title pt-2 mbr-fonts-style display-2"><strong>DIGITAL ENGINEERING TELECOM 
</strong></h2>
<div class="mbr-section-text">
</div>
<div class="block-content">
<div class="card p-3 pr-3">
<div class="media">
<div class="align-self-center card-img pb-3">
<span class="mbr-iconfont mbri-mobile" style="font-size: 40px;"></span>
</div>
<div class="media-body">
<h4 class="card-title mbr-fonts-style display-5"><strong>Mobile Broadband
</strong></h4>
</div>
</div>
<div class="card-box">
<p class="block-text mbr-fonts-style display-7">Smart Phone / Devices
<br/>Home, SOHO, Enterprises
<br/>UHD, AR/VR, Broadcasting <br/></p>
</div>
</div>
<div class="card p-3 pr-3">
<div class="media">
<div class="align-self-center card-img pb-3">
<span class="mbr-iconfont mbri-globe" style="font-size: 40px;"></span>
</div>
<div class="media-body">
<h4 class="card-title mbr-fonts-style display-5">Large Scale M2M communication
</h4>
</div>
</div>
<div class="card-box">
<p class="block-text mbr-fonts-style display-7">Logistic, fleet management, tracking, route optimisation
<br/>Smart building management systems, Marketing 
<br/>Smart – Agriculture, Metering, Surveillance <br/></p>
</div>
</div>
<div class="card p-3 pr-3">
<div class="media">
<div class="align-self-center card-img pb-3">
<span class="mbr-iconfont mbri-setting" style="font-size: 40px;"></span>
</div>
<div class="media-body">
<h4 class="card-title mbr-fonts-style display-5"><strong>Critical M2M Communication</strong></h4>
</div>
</div>
<div class="card-box">
<p class="block-text mbr-fonts-style display-7">Logistic, fleet management, tracking, route optimisation
<br/>Smart building management systems, Marketing 
<br/>Smart – Agriculture, Metering, Surveillance <br/></p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="features11 cid-spz3qyx5pS" id="features11-2w">
<div class="container">
<div class="col-md-12">
<div class="media-container-row">
<div class="align-left aside-content">
<h2 class="mbr-title pt-2 mbr-fonts-style display-2"><strong>DIGITAL TRANSFORMATION
</strong></h2>
<div class="mbr-section-text">
<p class="mbr-text mb-5 pt-3 mbr-light mbr-fonts-style display-5">
                        Vayunam has capabilities to guide your organization towards a tangible digital transformation
                        </p>
</div>
<div class="block-content">
<div class="card p-3 pr-3">
<div class="media">
<div class="media-body">
</div>
</div>
<div class="card-box">
<p class="block-text mbr-fonts-style display-7" style="text-align:justify">
                                   The world of technology is ever evolving and going digital is not just a technology play but pan across the business workflows that need to be refined for encompassing and enabling new business models, delivering worthy customer experience, enhancing productivity and driving informed decision making through rational data analytics. 
                                </p>
</div>
</div>
</div>
</div>
<div class="mbr-figure m-auto" style="width: 50%;">
<img alt="DigitalTransformation" src="assets/images/digitaltransformationnew.svg" title=""/>
</div>
</div>
</div>
</div>
</section>
<section class="mbr-section content4 cid-spgVnXhQ6Z" id="content4-2p">
<div class="container">
<div class="media-container-row">
<div class="title col-12 col-md-8">
<h2 class="align-center pb-3 mbr-fonts-style display-2"><strong>
                    SERVICES</strong><br/></h2>
</div>
</div>
</div>
</section>
<section class="features17 cid-spfYR5tWY5" id="features17-2n">
<div class="container-fluid">
<div class="media-container-row">
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<img alt="Consulting" class="imgSize" src="assets/images/imagess-238x212.png"/>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-7">
                            Consulting Services</h4>
</div>
</div>
</div>
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<a routerLink="/digital-transformation"><img alt="CloudMigration" class="imgSize" src="assets/images/imagesss-238x212.png"/></a>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-7">Cloud Migration
</h4>
</div>
</div>
</div>
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<img alt="Intergrations" class="imgSize" src="assets/images/imagesq23-238x212.png"/>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-7">Integration Services
</h4>
</div>
</div>
</div>
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<img alt="mso" class="imgSize" src="assets/images/imagesssa21-238x212.png"/>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-7">Managed Services
</h4>
</div>
</div>
</div>
</div>
<div id="arrowbox"><h3 style="padding-top: 12px;">SERVICES MAP</h3></div>
</div>
</section>
<section class="features17 cid-spgNP3donU" id="features17-2o">
<div class="container-fluid">
<div class="media-container-row">
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<img alt="CloudBased" class="imgSize" src="assets/images/images12sd-238x212.png"/>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-4">Cloud Based Optimization</h4>
</div>
</div>
</div>
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<img alt="Mobility" class="imgSize" src="assets/images/images2d-238x212.png"/>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-7">Mobility <br/>Enablement
</h4>
</div>
</div>
</div>
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<img alt="SmartInfra" class="imgSize" src="assets/images/images345-238x212.png"/>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-7">Deploy Smart 
<div>Infrastructures
</div></h4>
</div>
</div>
</div>
<div class="card p-3 col-6 col-md-6 my-col">
<div class="card-wrapper">
<div class="card-img">
<img alt="ManageData" class="imgSize" src="assets/images/images13-238x212.png"/>
</div>
<div class="card-box">
<h4 class="card-title pb-3 mbr-fonts-style display-7">Protect &amp;  
<div>Manage Data</div></h4>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="mbr-section info2 cid-spz4a23BSR" id="info2-2x">
<div class="container">
<div class="row main justify-content-center">
<div class="media-container-column col-12 col-lg-3 col-md-4">
<div class="mbr-section-btn align-left py-4"><a class="btn btn-primary display-4" routerLink="/contact-us">Contact us</a></div>
</div>
<div class="media-container-column title col-12 col-lg-7 col-md-6">
<h2 class="align-right mbr-bold mbr-white pb-3 mbr-fonts-style display-2">Ready to Elevate Your Experiences?</h2>
<h3 class="mbr-section-subtitle align-right mbr-light mbr-white mbr-fonts-style display-5">Let's help you navigate your next</h3>
</div>
</div>
</div>
</section>
